import React from 'react';
import PropTypes from 'prop-types';
import { athletePropTypes } from '../../hooks/UseAppContext';
import constants from '../../constants';
import AthleteSticker from '../AthleteSticker';

import styles from './AthletesList.module.scss';

function AthletesList({ athletes, evaluation, handleEvaluation }) {
  const list = [...athletes].sort((a, b) => {
    let response;
    const diff = b.eval - a.eval;

    if (diff !== 0) response = diff;
    else response = a.name.localeCompare(b.name);

    return response;
  });

  return (
    <section className={styles.wrapper}>
      <h3 className={styles.title}>{constants.athletes.title}</h3>
      <div className={styles.clip}>
        <ol className={styles.list}>
          {list.map((athlete, index) => {
            return (
              <AthleteSticker
                athlete={athlete}
                key={`AthleteSticker__key__${athlete.id}__${index}`}
                opinion={evaluation[athlete.id] ? evaluation[athlete.id] : 0}
                handleEvaluation={handleEvaluation}
              />
            );
          })}
        </ol>
      </div>
    </section>
  );
}

AthletesList.propTypes = {
  athletes: PropTypes.arrayOf(
    PropTypes.shape({ ...athletePropTypes }).isRequired
  ),
  evaluation: PropTypes.objectOf(PropTypes.number),
  handleEvaluation: PropTypes.func.isRequired,
};

export default AthletesList;
